import { z } from "zod";
import type { DocumentTypeConfig } from "../types";

export const RibDataSchema = z.object({
  iban: z.string(),
  bic: z.string().optional(),
  account_holder_last_name: z.string().optional(),
  account_holder_first_name: z.string().optional(),
});

export type RibData = z.infer<typeof RibDataSchema>;

export const RibExtractionSchema = z.object({
  isValidDocumentType: z.boolean(),
  reason: z.string().optional(),
  iban: z.string().nullable(),
  bic: z.string().nullable(),
  account_holder_last_name: z.string().nullable(),
  account_holder_first_name: z.string().nullable(),
});

export type RibExtraction = z.infer<typeof RibExtractionSchema>;

export const RibContextSchema = z.object({
  talentId: z.guid(),
});

export type RibContext = z.infer<typeof RibContextSchema>;

type RibConfig = DocumentTypeConfig<typeof RibDataSchema, typeof RibContextSchema>;

export const RIB_CONFIG: RibConfig = {
  documentType: "rib",
  documentName: "RIB",
  maxFiles: 1,
  acceptedMimeTypes: ["image/jpeg", "image/png", "application/pdf"],
  dataSchema: RibDataSchema,
  contextSchema: RibContextSchema,
  requiredFields: ["iban"],
  fieldLabels: {
    iban: "IBAN",
    bic: "BIC",
    account_holder_last_name: "Nom du titulaire du compte",
    account_holder_first_name: "Prénom du titulaire du compte",
  },
};
